import { MYEV_API_BASE } from '../config';
import { setUpClickHandlers } from '../utils/clickHandlers';

/**
 * Set up click handlers on traits list.
 *
 * @uses setUpClickHandlers
 * @see sections/product-template.liquid
 */
export async function drawTraitsList() {
  const $mountNode = $(document.getElementById('traits-list'));

  if (!$mountNode.length) {
    return;
  }

  function renderLearnMore(url) {
    return url
      ? `<p>Learn More: <a href="${url}" target="_blank" rel="nofollow">${url}</a></p>`
      : '';
  }

  function renderCitations(zippedSources) {
    if (zippedSources.length > 0) {
      const sourcesMarkup = zippedSources
        .map(
          (source) =>
            `<a href="${source.url}" target="_blank" rel="nofollow">${source.author}</a>`
        )
        .join(',');
      return `<cite class="trait-citations">Citations: ${sourcesMarkup}</cite>`;
    }
    return '';
  }

  if ($mountNode.closest('.product-template-brd').length > 0) {
    const traitsListObjectAll = await $.get(`${MYEV_API_BASE}/traits-list`);
    const traitsListObject = traitsListObjectAll.breeder;

    const traitListMarkup = [];

    // eslint-disable-next-line guard-for-in -- @fixme This should be taken care of by the hasOwnProperty check.
    for (const categoryIndex in traitsListObject) {
      if (traitsListObject.hasOwnProperty(categoryIndex)) {
        let categoryName = '';
        const listGroupMarkup = traitsListObject[categoryIndex]
          .map((trait) => {
            categoryName = trait.category;
            const learnMoreLink = renderLearnMore(trait.doggeneticsLink);
            const citations = renderCitations(trait.zippedSources);
            return `<li>
                <h6 class="trait-label">${trait.label}</h6>
                <p>${trait.description}</p>
                ${learnMoreLink}
                ${citations}
                </li>`;
          })
          .join('');

        traitListMarkup.push(
          `<h6>${categoryName}</h6><ul>${listGroupMarkup}</ul>`
        );
      }

      if (traitListMarkup.length > 0) {
        const html = ['<h4>We test for the following traits:</h4>'];
        html.push('<ul class="accordion__root accordion">');
        html.push(
          traitListMarkup
            .map((category) => `<li class="accordion__item">${category}</li>`)
            .join('')
        );
        html.push('</ul>');
        $mountNode.html(html.join(''));
      }
    }
  }

  setUpClickHandlers($mountNode);
}
